export function projectLandingPath(projectId: string) {
  return `/project/${projectId}`
}
